import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class ContactsFormService {
  public url: string;
  public identity;
  public token;
  public headers: HttpHeaders;

  constructor(private httpClient: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem("token"));

    if (this.token === "undefined") {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  }

  getCountries(): Observable<any> {
    return this.httpClient.get<any>(`${this.url}/geos/countries`);
  }

  getStates(countryId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.url}/geos/get-states/${countryId}`);
  }

  getCities(stateId: number): Observable<any> {
    return this.httpClient.get<any>(`${this.url}/geos/get-cities/${stateId}`);
  }

  create(token, task): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(`${this.url}/contactsform/new?page=${page}`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  edit(token, task, id): Observable<any> {
    // const json = JSON.stringify(task);
    let json = encodeURIComponent(JSON.stringify(task));
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(`${this.url}/contactsform/edit/${id}?page=${page}`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  getContact(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(`${this.url}/contactsform/detail/${id}?page=${page}`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  getContacts(token, page = 1): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/list?page=${page}`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  getContactsByRep(
    token,
    repId,
    type,
    perPage,
    page = 1,
    filtros = []
  ): Observable<any> {
    let url = `${this.url}/contactsform/listbyreptype/${repId}/${type}?page=${page}&perpage=${perPage}`;

    // Añadir los filtros a la URL
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        console.log("URL después de añadir valor:", url);
        url += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        console.log("URL después de añadir valor:", url);

        if (filtro.type) {
          url += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
        }
      }
    }

    console.log("URL final:", url);
    return this.petition(url);
    // if (busqueda !== "") {
    //   const task = {
    //     busqueda: busqueda,
    //   };

    //   const json = JSON.stringify(task);
    //   const params = `json=${json}&authorization=${token}`;

    //   return this.httpClient
    //     .post<any>(
    //       `${this.url}/contactsform/search?page=${page}&perpage=${perPage}`,
    //       params,
    //       { headers }
    //     )
    //     .pipe(map((res) => res));
    // } else {
    // const params = `authorization=${token}`;

    // return this.httpClient
    //   .post<any>(
    //     `${this.url}/contactsform/listbyreptype/${repId}/${type}?page=${page}&perpage=${perPage}`,
    //     params,
    //     { headers }
    //   )
    //   .pipe(map((res) => res));
    // }
  }

  getContactsByRepSort(
    token,
    repId,
    type,
    perPage,
    page = 1,
    filtros = [],
    filterrigh,sortStates
  ): Observable<any> {
    let url = `${this.url}/contactsform/listbyreptype/${repId}/${type}?page=${page}&perpage=${perPage}`;
    let json = {sort :[filterrigh], order:sortStates };
    // Añadir los filtros a la URL
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        console.log("URL después de añadir valor:", url);
        url += `&${filtro.key}=${encodeURIComponent(filtro.value)}`;
        console.log("URL después de añadir valor:", url);

        if (filtro.type) {
          url += `&${filtro.key_type}=${encodeURIComponent(filtro.type)}`;
        }
      }
    }

    console.log("URL final:", url);
    return this.petition(url,json);
    // if (busqueda !== "") {
    //   const task = {
    //     busqueda: busqueda,
    //   };

    //   const json = JSON.stringify(task);
    //   const params = `json=${json}&authorization=${token}`;

    //   return this.httpClient
    //     .post<any>(
    //       `${this.url}/contactsform/search?page=${page}&perpage=${perPage}`,
    //       params,
    //       { headers }
    //     )
    //     .pipe(map((res) => res));
    // } else {
    // const params = `authorization=${token}`;

    // return this.httpClient
    //   .post<any>(
    //     `${this.url}/contactsform/listbyreptype/${repId}/${type}?page=${page}&perpage=${perPage}`,
    //     params,
    //     { headers }
    //   )
    //   .pipe(map((res) => res));
    // }
  }

  searchContactsByRep(token, task, perPage, page): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(
        `${this.url}/contactsform/search?page=${page}&perpage=${perPage}`,
        params,
        { headers }
      )
      .pipe(map((res) => res));
  }

  getContactsByDate(
    token,
    data,
    page = 1,
    perPage = 10,
    busqueda = "",
    filtros = []
  ): Observable<any> {
    let url;
    if (data.type === "blacklist") {
      url = `${this.url}/contactsform/listbystatus/BLACKLISTED?`;
    } else {
      url = `${this.url}/contactsform/listbydateandtype?`;
    }

    url = url + "page=" + page + "&perpage=" + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }

    return this.petition(url, data);

    /*const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.httpClient
      .post<any>(`${url}?page=${page}`, params, { headers })
      .pipe(map(res => res));*/
  }
  getContactsByrepdateandtype(
    token,
    data,
    page = 1,
    perPage = 10,
    busqueda = "",
    filtros = []
  ): Observable<any> {
    let url;
    if (data.type === "blacklist") {
      url = `${this.url}/contactsform/listbystatus/BLACKLISTED?`;
    } else {
      url = `${this.url}/contactsform/listbyrepdateandtype?`;
    }

    url = url + "page=" + page + "&perpage=" + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }

    return this.petition(url, data);

    /*const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });

    return this.httpClient
      .post<any>(`${url}?page=${page}`, params, { headers })
      .pipe(map(res => res));*/
  }

  getContactsByType(token, page = null, data): Observable<any> {
    let url;
    if (data.type === "blacklist") {
      url = `${this.url}/contactsform/listbystatus/BLACKLISTED`;
    } else {
      url = `${this.url}/contactsform/listbytype`;
    }

    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${url}?page=${page}`, params, { headers })
      .pipe(map((res) => res));
  }
  getContactsForMap(token, page = null, data): Observable<any> {
    let url;
   
      url = `${this.url}/contactsform/leadsbymap`;
  

    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${url}?page=${page}&perpage=10000`, params, { headers })
      .pipe(map((res) => res));
  }

  getContactsForMapByList(token, page = null,perpage=null, data,filtros: any[] = []): Observable<any> {
    let url = `${this.url}/contactsform/leadsbymapByList?page=${page}&perpage=${perpage}`;

    
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        
        url += `&${filtro.key}=${filtro.value}`;
  
        
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
   
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
  
    
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  
   
    return this.httpClient
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }

  getcityForMapByList(token, page = null,perpage=null, data,filtros: any[] = []): Observable<any> {
    let url = `${this.url}/contactsform/leadsbymapByCity?page=${page}&perpage=${perpage}`;

    
    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        
        url += `&${filtro.key}=${filtro.value}`;
  
        
        if (filtro.type) {
          url += `&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
  
   
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
  
    
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
  
   
    return this.httpClient
      .post<any>(url, params, { headers })
      .pipe(map((res) => res));
  }
  assignBulkRep(token, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/assignbulk`, params, { headers })
      .pipe(map((res) => res));
  }

  deleteBulk(token, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/removebulk`, params, { headers })
      .pipe(map((res) => res));
  }

  deleteContacts(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(`${this.url}/contactsform/remove/${id}?page=${page}`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  banearContacts(token, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/blacklist/new`, params, { headers })
      .pipe(map((res) => res));
  }

  assingRep(token, id, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/assign/${id}?page=1`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  setranking(token, id, data): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/setranking/${id}?page=1`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  unassignedRep(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient
      .post<any>(`${this.url}/contactsform/unassign/${id}?page=1`, params, {
        headers,
      })
      .pipe(map((res) => res));
  }

  unblackContacts(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(
        `${this.url}/contactsform/unblack/${id}?page=${page}`,
        params,
        { headers }
      )
      .pipe(map((res) => res));
  }
  unblackContactsRep(token, id): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this.httpClient
      .post<any>(
        `${this.url}/contactsform/unblackbyrep/${id}?page=${page}`,
        params,
        { headers }
      )
      .pipe(map((res) => res));
  }

  getNewsletterContacts(
    token,
    page = 1,
    perPage = 10,
    busqueda = "",
    filtros = []
  ): Observable<any> {
    let url;

    url = `${this.url}/user/listnewsletter?`;

    let json = null;
    if (busqueda !== "") {
      json = {
        busqueda: busqueda,
      };
    }

    url = url + "page=" + page + "&perpage=" + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }

    return this.petition(url, json);
  }

  getNewsletterContactsSort(
    token,
    page = 1,
    perPage = 10,
    busqueda = "",
    filtros = [],
    filterrigh,sortStates
    
  ): Observable<any> {
    let url;

    url = `${this.url}/user/listnewsletter?`;

    let json: { [key: string]: any } = { sort: [filterrigh], order: sortStates };
    if (busqueda !== "") {
      json.busqueda = busqueda;
    }

    url = url + "page=" + page + "&perpage=" + perPage;

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + "&" + filtro.key + "=" + filtro.value;

        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }

    return this.petition(url, json);
  }

  deleteNewsBulk(token: any, data: any): Observable<any> {
    const json = JSON.stringify(data);
    const params = `json=${json}&authorization=${token}`;
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.httpClient.post<any>(
      `${this.url}/user/removenewsletter`,
      params,
      { headers }
    );
  }

  getContactsByDateStadistics(
    token: any,
    page: any = 1,
    data: any
  ): Observable<any> {
    const url =
      data.type === "blacklist"
        ? `${this.url}/contactsform/listbystatus/BLACKLISTED`
        : `${this.url}/contactsform/listbydateandtype`;
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    const body = {
      json: JSON.stringify(data),
      authorization: token,
    };

    console.log("body:: ", body);

    return this.httpClient.post(
      `${url}?page=${page}`,
      this.getQueryString(body),
      { headers }
    );
  }

  private getQueryString(params: any): string {
    return Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join("&");
  }

  petition(url, json = null, type = null) {
    let params = "authorization=" + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + "&json=" + json;
    }

    if (type != null) {
      params = params + "&type=" + type;
    }

    return this.httpClient.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => {
        /*if (res.code === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }*/
        return res;
      })
    );
  }
}
